__turbopack_context__.v({
  "active-bg": "tabs-module__Pr0bMq__active-bg",
  "active-tab-background": "tabs-module__Pr0bMq__active-tab-background",
  "tab": "tabs-module__Pr0bMq__tab",
  "tab-bar": "tabs-module__Pr0bMq__tab-bar",
  "theme-moss": "tabs-module__Pr0bMq__theme-moss",
  "theme-smoke": "tabs-module__Pr0bMq__theme-smoke",
  "theme-standard": "tabs-module__Pr0bMq__theme-standard",
});
